/**
 * Translate the given key.
 */
window.trans = function (key, replace = {}) {
    let translation,
        translationNotFound = true;

    try {
        translation = key
            .split(".")
            .reduce(
                (t, i) => t[i] || null,
                window._translations
            );

        if (translation) {
            translationNotFound = false;
        }
    } catch (e) {
        translation = key;
    }

    if (translationNotFound) {
        translation = window._translations["json"][key]
                      ? window._translations["json"][key]
                      : key;
    }

    $.each(replace, (key, value) => {
        translation = translation.replace(":" + key, value);
    });

    return translation;
};

/* window.trans = function (key, replace = {})
{
    let translation = key.split('.').reduce((t, i) => t[i] || null, window.translations);

    for (var placeholder in replace) {
        translation = translation.replace(`:${placeholder}`, replace[placeholder]);
    }

    return translation;
} */

window.trans_choice = function (key, count = 1, replace = {}) {
    let translation = key.split('.').reduce((t, i) => t[i] || null, window._translations).split('|');

    translation = count > 1 ? translation[1] : translation[0];

    for (var placeholder in replace) {
        translation = translation.replace(`:${placeholder}`, replace[placeholder]);
    }

    return translation;
}